import * as React from "react";
import { MadFragment, UserMadFragment } from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";

type FollowUpRoleBadgeProps = {
  mad: MadFragment;
  user: UserMadFragment;
};

export const FollowUpRoleBadge: React.FC<FollowUpRoleBadgeProps> = React.memo(
  ({ mad, user }) => {
    const t = useTranslations();

    if (mad.referentIds.includes(user.id)) {
      return (
        <span className="flex-shrink-0 inline-block px-3 py-0.5 text-blue-700 text-sm leading-5 font-medium bg-blue-100 rounded-full">
          {t("mads.referent", { count: 0 })}
        </span>
      );
    } else if (mad.talent.id === user.id) {
      return (
        <span className="flex-shrink-0 inline-block px-3 py-0.5 text-purple-700 text-sm leading-5 font-medium bg-purple-100 rounded-full">
          {t("mads.talent")}
        </span>
      );
    }
  
    return null;
  }
);
